import {
   GET_COUPON_LIST_FAILED,GET_COUPON_LIST_REQUESTED, GET_COUPON_LIST_SUCCESS, GET_APPLY_COUPON_FAILED, GET_APPLY_COUPON_REQUESTED, GET_APPLY_COUPON_SUCCESS, GET_APPLY_COUPON_RENTAL_FAILED, GET_APPLY_COUPON_RENTAL_REQUESTED, GET_APPLY_COUPON_RENTAL_SUCCESS,
   GET_APPLY_COUPON_RENTAL_CLEAR,
   GET_APPLY_COUPON_CLEAR
  } from 'resources/actionTypes';
  
  const initialState = {
    userCouponList: [],
    loading: false,
    error: null,
  };

  const initialApplyCouponState = {
    userCouponApply: [],
    loading: false,
    error: null,
  };

  const initialApplyRentalCoupon = {
    userCouponRental: [],
    loading: false,
    error: null,
  };
  
  export function userCouponList(state = initialState, action) {
    switch (action.type) {
      case GET_COUPON_LIST_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_COUPON_LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          userCouponList: action.couponListData          ,
        };
      case GET_COUPON_LIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
    }
  }

  export function userCouponApply(state = initialApplyCouponState, action) {
    switch (action.type) {
      case GET_APPLY_COUPON_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_APPLY_COUPON_SUCCESS:
        return {
          ...state,
          loading: false,
          userCouponApply: action.couponApplyData,
        };
      case GET_APPLY_COUPON_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
        case GET_APPLY_COUPON_CLEAR:
        return {
          ...state,
          loading: false,
          userCouponApply: '',
        };
      default:
        return state;
    }
  }

  export function userRentalCouponApply(state = initialApplyRentalCoupon, action) {
    switch (action.type) {
      case GET_APPLY_COUPON_RENTAL_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_APPLY_COUPON_RENTAL_SUCCESS:
        return {
          ...state,
          loading: false,
          userCouponRental: action.couponRentalData,
        };
      case GET_APPLY_COUPON_RENTAL_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
        case GET_APPLY_COUPON_RENTAL_CLEAR:
        return {
          ...state,
          loading: false,
          userCouponRental: '',
        };
      default:
        return state;
    }
  }
  
  